import { render } from "./Reset.vue?vue&type=template&id=6fce07ba"
import script from "./Reset.vue?vue&type=script&setup=true&lang=js"
export * from "./Reset.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/Passwords/Reset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fce07ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fce07ba', __exports__)) {
    api.reload('6fce07ba', __exports__)
  }
  
  module.hot.accept("./Reset.vue?vue&type=template&id=6fce07ba", () => {
    api.rerender('6fce07ba', render)
  })

}


export default __exports__